import { useEffect, useState } from 'react';

const KeyboardAware = () => {
  const [isKeyboardOpen, setKeyboardOpen] = useState(false);
  
  useEffect(() => {
    const handleKeyboardOpen = () => {
      if (!isKeyboardOpen) { 
        setKeyboardOpen(true);
      }
    };
  
    const handleKeyboardClose = () => {
      if (isKeyboardOpen) { 
        setKeyboardOpen(false);
      }
    };
    // Добавляем обработчики событий для всех элементов ввода
    const inputElements = document.querySelectorAll('input, textarea');
    inputElements.forEach((input) => {
      input.addEventListener('focus', handleKeyboardOpen);
      input.addEventListener('blur', handleKeyboardClose);
    });

    return () => {
      // Удаляем обработчики событий
      inputElements.forEach((input) => {
        input.removeEventListener('focus', handleKeyboardOpen);
        input.removeEventListener('blur', handleKeyboardClose);
      });
    };
  }, [isKeyboardOpen]);

  return [isKeyboardOpen,setKeyboardOpen]
};

export default KeyboardAware;
